import React, { Component } from 'react'
import { func, array } from 'prop-types'
import { Box, Flex } from 'grid-styled'
// import Hide from '../../../styles/utilities/Hide'
// Components
// import DropdownList from './DropdownList'
// import Dropdown from './Dropdown'
// import DotButton from 'app/elements/DotButton'
// import Checkbox from 'app/elements/Checkbox'
import IdentifiersListItem from '../../elements/IdentifiersListItemForPartners'
// Styles
import { ListContainer, ListItem } from './styles'
// import { blueGray } from 'styles/settings/colors'

export default class IdentifiersList extends Component {
  static propTypes = {
    identifiers: array.isRequired,
    checkboxValues: array.isRequired,
    handleSelectItem: func.isRequired,
    handleSelectAll: func.isRequired
    // handleLoadMoreItems: func.isRequired
  }
  static defaultProps = {
    identifiers: [],
    checkboxValues: [],
    handleSelectItem: () => {},
    handleSelectAll: () => {},
    handleIncreaseList: () => {}
  }

  constructor(props) {
    super(props)
    this.state = {
      isItemDropdownOpen: null,
      itemDropdownId: null,
      isDropdownOpen: false,
      veloeTagsOptions: ['Ativa', 'Bloqueada'],
      selectedOption: 'Ativa'
    }
    // window.onscroll = () => {
    //   if (
    //     window.innerHeight +
    //       document.documentElement.scrollTop +
    //       document.getElementById('footer').offsetHeight >=
    //     document.documentElement.offsetHeight
    //   ) {
    //     // props.handleLoadMoreItems()
    //   }
    // }
  }

  handleDropdown = () => {
    this.setState({ isDropdownOpen: !this.state.isDropdownOpen })
  }

  handleItemDropdown = itemDropdownId => () => {
    if (itemDropdownId) {
      return this.setState({ isItemDropdownOpen: true, itemDropdownId })
    }
    this.setState({ isItemDropdownOpen: false, itemDropdownId: null })
  }

  handleSelectOption = selectedOption => {
    this.setState({ selectedOption, isDropdownOpen: false })
  }

  render() {
    const {
      identifiers,
      checkboxValues,
      handleSelectItem,
      // handleSelectAll,
      handleCreateInf
    } = this.props
    const { selectedOption } = this.state
    const itemStatus = selectedOption === 'Bloqueada' ? 'INATIVO' : 'ATIVO'
    // const isAllChecked = checkboxValues.length === identifiers.length
    // const identifiersFiltered = identifiers.filter(({ situacao }) => situacao === itemStatus)
    return (
      <ListContainer>
        <ListItem>
          <Flex width={1} direction={['row', 'row']}>
            <Box width={[4 / 12, 2 / 12]}>placa</Box>
            <Box width={[5 / 12, 2 / 12]}>VeloeTag</Box>
            <Box width={[3 / 12, 2 / 12]}>status</Box>
          </Flex>
        </ListItem>
        {identifiers.map((vehicle, index) => (
          <IdentifiersListItem
            checkboxValues={checkboxValues}
            vehicle={vehicle}
            handleSelectItem={handleSelectItem}
            key={index}
            handleCreateInf={handleCreateInf}
            itemDropdownId={this.state.itemDropdownId}
            isItemDropdownOpen={this.state.isItemDropdownOpen}
            handleItemDropdown={this.handleItemDropdown}
            itemStatus={itemStatus}
          />
        ))}
      </ListContainer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/IdentifiersListForPartners/index.js